import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Rishabh Mainwal </span>
            from <span className="purple"> Rajasthan, India.</span>
            <br />
            I am currently employed as a Technical Consultant at AVSS INDIA.
            <br />
            I have completed <span className="purple"> BCA(2020) and MCA(2022)</span> from <span className="purple"> Rajasthan University. </span>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Cooking
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Everything is possible through code!"{" "}
          </p>
          <footer className="blockquote-footer">Rishabh Mainwal</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
